const getHeaderHeight = () => {
  const navbarEl = document.querySelector('[data-ref="header"]');
  return navbarEl ? navbarEl.offsetHeight : 0;
};

const hasUrlParam = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.has(param);
};

const getUrlParamValue = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
};

const getAllUrlParamValues = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.getAll(param);
};

const removeParamFromUrl = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  urlParams.delete(param);
  window.history.replaceState(null, null, `${window.location.pathname}?${urlParams.toString()}`);
};

const createQueryStringFromParams = (params) => {
  let searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (!value.length) return;
      value.forEach((item) => searchParams.append(`${key}[]`, item));
    } else if (value || Number.isFinite(value)) {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

const scrollTo = (el, offset = getHeaderHeight()) => {
  const elPositionY = el.getBoundingClientRect().top - offset;
  if (elPositionY < 0) window.scroll(0, elPositionY + document.documentElement.scrollTop);
};

export {
  getHeaderHeight,
  hasUrlParam,
  getUrlParamValue,
  getAllUrlParamValues,
  removeParamFromUrl,
  createQueryStringFromParams,
  scrollTo
};
